export default "__VITE_ASSET__9379a948__"